import React from 'react';
import { Card, Typography, Space, Tag, Divider } from 'antd';
import { SettingOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

const GeneralSettings: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Title level={3}>
              <SettingOutlined style={{ marginRight: 8 }} />
              General Settings
            </Title>
            <Tag color="blue">Upcoming Feature</Tag>
          </div>
          
          <Divider />
          
          <div>
            <Title level={4}>System Configuration</Title>
            <Paragraph>
              This page will contain general system settings and configuration options.
              Features will include:
            </Paragraph>
            <ul>
              <li>Application theme and appearance settings</li>
              <li>Language and localization preferences</li>
              <li>Default dashboard configuration</li>
              <li>System notifications preferences</li>
              <li>Data display and formatting options</li>
            </ul>
          </div>
          
          <div style={{ 
            background: '#f6f8fa', 
            padding: '16px', 
            borderRadius: '8px',
            border: '1px solid #e1e4e8'
          }}>
            <Space>
              <InfoCircleOutlined style={{ color: '#1890ff' }} />
              <Text type="secondary">
                This feature is currently under development and will be available soon.
              </Text>
            </Space>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default GeneralSettings;
